import './style.css'
import TableAHSF from "../../Components/TableAHSF"
import PopupAHSF from "../../Components/PopupAHSF"

import Swal from "sweetalert2"
import { useDispatch, useSelector } from "react-redux"

import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { GetReportByAppGuid } from '../../Redux/Reducers/ReportStage/Report'
import { decryptToken } from '../../Services/Account/EncryptionParams'
import { setRefreshTable } from '../../Redux/Reducers/VariousVariables'
import AddExpectedObjectivesForReport from './AddExpectedObjectivesForReport'
import { DeleteExpectedObjectivesForStage } from '../../Redux/Reducers/ReportStage/ExpectedObjectivesForStag'

const ExpectedObjectivesForReport = (props) => {
    const dispatch = useDispatch()
    const [expectedObjectivesForStageId,setExpectedObjectivesForStageId]=useState(null)
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
    const reports = useSelector((state) => state.ReportByAppGuidReducers.ReportByApp)
    const tokens = useParams().token
    const addExpectedObjectivesForReport=useSelector((state)=>state.ExpectedObjectivesForStage.ExpectedObjectivesAdd)
    const DeleteExpectedObjectivesForReport=useSelector((state)=>state.ExpectedObjectivesForStage.ExpectedObjectivesDelete)

    const [appGuid, setAppGuid] = useState(null)
        // console.log(decryptToken(tokens),"sdlskdlskdd");
    
        useEffect(() => {
    
    
            if (tokens) {
                var token = decryptToken(tokens)
                setAppGuid(token)
                // console.log(token,"sdkjskijdsiiisd");
    
            }
    
        }, [])
    useEffect(() => {
        dispatch(GetReportByAppGuid({ aI_ApplicationInformationId: appGuid }))

    }, [appGuid])

    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "stagesName",
            ShowStatus: true,
            NmaeColumn: "المرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "objectiveName",
            ShowStatus: true,
            NmaeColumn: "الهدف",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "subObjectives",
            ShowStatus: true,
            NmaeColumn: "الأهداف الفرعية المطلوب تحقيقها",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "percentageMainAndSubObjecive",
            ShowStatus: true,
            NmaeColumn: "(%) الأهداف الفرعية / الهدف الرئيسي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        }
    ];
  

    const OtherMainBtns = [


        {
            Click: async (e) => {
                Swal.fire({
                    title: state.jsonData.deleteTitlePopUp?.nameAR,
                    icon: "error",
                    // iconHtml: "؟",
                    confirmButtonText: "تأكيد",
                    cancelButtonText: "الغاء",
                    showCancelButton: true,
                    showCloseButton: true,
                }).then((res) => {
                    if (res.isConfirmed == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الحذف بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                            // width: "500px",
                        });

                        dispatch(DeleteExpectedObjectivesForStage({pR_ExpectedObjectivesForStageId:e.target.value}))

                    }
                });
            },
            content: "",
            className: "bi bi-trash",
            id: "deleteBtn",
            title: "حذف",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                console.log(e.target.value,"sdlkslkdlkslkd");
                
                 setExpectedObjectivesForStageId(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-pencil-square",
            id: "editBtn",
            title: "تعديل",
            ShowStatus: true,
        },

    ];
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => { },
        componentBody: <AddExpectedObjectivesForReport appGuid={appGuid} />,
        maxWidth: "500px",
        maxHeight: "800px",
        title: "الإنجازات المتوقعة على الأهداف للمرحلة",
    };

    useEffect(() => {
        dispatch(setRefreshTable());
    }, [])


    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };



        useEffect(()=>{
            dispatch(setRefreshTable());
        },[addExpectedObjectivesForReport,DeleteExpectedObjectivesForReport])

    return (

        <>
            {
                reports ? <TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={"pR_ExpectedObjectivesForStageId"}
                    valueButtonAction={"pR_ExpectedObjectivesForStageId"}
                    URL={`api/PR_ExpectedObjectivesForStage/GetLisExpectedObjectivesByReportId`}
                    UrlBody={{
                        reportGuid: reports?.pR_ReportsId,
                    }}
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={""}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    tableBtn={true}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={PopupOPjectData}
                    popUpTitle={"معلومات الطلب"}

                /> : <></>
            }

            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                   <AddExpectedObjectivesForReport pR_ExpectedObjectivesForStageId={expectedObjectivesForStageId} appGuid={appGuid} tackAction={"edit"} />
                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />

            <PopupAHSF
                title={"الأهداف"}
                componentBody={
                    <></>

                }
                maxWidth="700px"
                maxHeight="800px"
                isPopupOpenStatus={false}
                isPopupOpenFunction={false}
            />

        </>
    )
}

export default ExpectedObjectivesForReport